import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import { AuctionPaddleUser, Invoice, InvoiceLine, Person } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-deposit-overview',
    templateUrl: './deposit-overview.component.html',
    styleUrls: ['./deposit-overview.component.scss'],
    standalone: false,
})
export class DepositOverviewComponent implements OnInit {
    private router = inject(Router);

    auctionPaddleInfos: any[] = [];
    nonDepositedBatches: any[] = [];
    people: Person[];
    months = [
        { id: -1, name: 'All UnDeposited' },
        { id: 1, name: 'January' },
        { id: 2, name: 'February' },
        { id: 3, name: 'March' },
        { id: 4, name: 'April' },
        { id: 5, name: 'May' },
        { id: 6, name: 'June' },
        { id: 7, name: 'July' },
        { id: 8, name: 'August' },
        { id: 9, name: 'September' },
        { id: 10, name: 'October' },
        { id: 11, name: 'November' },
        { id: 12, name: 'December' },
    ];
    selectedAmount = 0;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('itemDataGrid') itemDataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const auctionPaddleInfos = await this.uow.getDeposits(true);
        auctionPaddleInfos.forEach((paddle) => {
            paddle.displayName = `Paddle ${paddle.paddleNumber} --- ${paddle.assignedTo}`;
        });
        this.auctionPaddleInfos = auctionPaddleInfos;
        this.nonDepositedBatches = await this.uow.getDeposits(false, 'contributions.lines, status, specialAccount');
        this.appInfo.pleaseWaitHide();
    }

    onPaddleToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarText',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                template: 'toolbarSelect',
                location: 'before',
            }
        );
    }

    onSelectionChanged(e) {
        const selectedRows = e.selectedRowsData;
        this.selectedAmount = 0;
        selectedRows.forEach((row) => {
            this.selectedAmount += row.batchTotalAmount;
        });
    }

    rowPrepare(e) {}

    itemRowDoubleClick(e) {}

    markAsDeposited() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (selectedRows.length === 0) return;

        const months = this.months.slice( 1);

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Deposit Month',
                dialogPrompt: 'Select the month for the deposit',
                // dialogMessage: 'Select the month for the deposit',
                mode: 'selectWithId',
                dialogValueArray: months,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });

        selectedRows.forEach((row) => {
            row.deposited = moment(new Date()).startOf('day').toDate();
            row.depositedBy = this.auth.currentUser.userName;
        });
        this.uow.commit();
    }
}
